import { render, staticRenderFns } from "./OrderProgress.vue?vue&type=template&id=7b4d13c0&scoped=true&"
import script from "./OrderProgress.vue?vue&type=script&lang=js&"
export * from "./OrderProgress.vue?vue&type=script&lang=js&"
import style0 from "./OrderProgress.vue?vue&type=style&index=0&id=7b4d13c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4d13c0",
  null
  
)

export default component.exports